import { useNavigate } from "react-router-dom";

const SubscriptionEndBadge = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#FF4747]/10 gap-3 p-3 rounded-xl border border-[#FF4747] flex w-full justify-between items-center">
      <span className="text-[#21272A]/60 text-sm">
        Your subscription has ended. Activate your subscription to get our bots
        working.
      </span>
      <button
        onClick={() => navigate("/account?tab=subscription")}
        className="w-full max-w-[100px] px-5 py-2 bg-[#2D224E] text-white rounded-lg text-sm font-medium hover:bg-[#241b59] transition"
      >
        Activate
      </button>
    </div>
  );
};

export default SubscriptionEndBadge;
